/* eslint-disable import/no-anonymous-default-export */
import axiosInstance, { axiosInstanceNoAuth } from "../axios/axios-configuration"; // axiosInstanceNoAuth: Istanza di Axios per chiamate non autenticate
import { CancelToken } from "axios";
import { IAppConfiguration, IArxeiaConfiguration } from "../shared/interfaces";

const controller = 'ArxeiaConfigurations';



const getArxeiaConfigurations = (cancelToken?: CancelToken): Promise<IArxeiaConfiguration[]> => {
    return axiosInstance.get(`${controller}/GetArxeiaConfigurations`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const updateArxeiaConfigurations = (configs: IArxeiaConfiguration[], cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.put(`${controller}/UpdateConfigurations`, configs, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getFEConfigurations = (cancelToken?: CancelToken): Promise<IAppConfiguration> => {
    // uso axiosInstanceNoAuth: Istanza di Axios per chiamate non autenticate
    return axiosInstanceNoAuth.get(`${controller}/GetFEConfigurations`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

export default {
    getArxeiaConfigurations,
    updateArxeiaConfigurations,
    getFEConfigurations
}